export default {
  header: {
    notes: 'Header in user registration form',
    message: 'User registration',
  },
  text: {
    notes: 'Information text in registration form',
    message:
      "{{inviterFirstName}} {{inviterLastName}} has invited you to SAM in the role of {{role}} for {{customer}}! Just a few details to finalize your registration. Don't worry, you can edit all preferences later.",
  },
  personalInformation: {
    notes: 'Personal information header',
    message: 'Personal information',
  },
  accountRecoveryInformation: {
    notes: 'Account recovery information header',
    message: 'Account recovery information',
  },
  notificationPreferences: {
    notes: 'Notification preferences header',
    message: 'Notification preferences',
    email: {
      notes: 'Receive e-mail notifications label',
      message: 'Receive e-mail notifications',
    },
    push: {
      notes: 'Receive push notifications label',
      message: 'Receive push notifications',
    },
    sms: {
      notes: 'Receive SMS notifications label',
      message: 'Receive SMS notifications',
    },
  },
  agreements: {
    notes: 'SAM agreements header',
    message: 'SAM agreements',
    agreeText: {
      notes: 'Agreement summary text (I agree and accept ....)',
      message:
        'I agree and accept the {{termsOfServiceName}} and the {{dataProcessingName}} and by clicking Accept, I hereby represent and warrant that I have full capacity and authority to bind the Customer to these agreements and that the Customer will ensure that all individual users from Customer will comply with the SAM Acceptable Use Policy and be made aware of the SAM Privacy Policy available below.',
    },
  },
  action: {
    register: {
      notes: 'Register action',
      message: 'Register',
    },
  },
  complete: {
    header: {
      notes: 'Header in registration complete dialog',
      message: 'Check your inbox',
    },
    text: {
      notes: 'Text in registration complete dialog',
      message:
        'One more thing! Please activate the link which has just been sent to your email.',
    },
  },
  activated: {
    header: {
      notes: 'Header in user activated dialog',
      message: "Now you're ready",
    },
    text: {
      notes: 'Text in user activated dialog',
      message:
        'Your user account is all set, {{username}}! Go ahead and proceed to login.',
    },
  },
};
